package one.healthium.domain.user.models

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class FoodPhotoQuotaModel(
    val limit: Int,
    val remaining: Int,
    val resetAt: Instant,
)
